import React from "react";

const BatteryFull = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.2497 4.75H3.16634C2.29189 4.75 1.58301 5.45888 1.58301 6.33333V12.6667C1.58301 13.5411 2.29189 14.25 3.16634 14.25H14.2497C15.1241 14.25 15.833 13.5411 15.833 12.6667V6.33333C15.833 5.45888 15.1241 4.75 14.2497 4.75Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.54102 7.91663V11.0833V7.91663ZM8.70768 7.91663V11.0833V7.91663ZM11.8744 7.91663V11.0833V7.91663ZM15.8327 7.91663H17.0202C17.1252 7.91663 17.2258 7.95833 17.3001 8.03256C17.3743 8.1068 17.416 8.20748 17.416 8.31246V10.6875C17.416 10.7924 17.3743 10.8931 17.3001 10.9674C17.2258 11.0416 17.1252 11.0833 17.0202 11.0833H15.8327V7.91663Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BatteryFull;
